import {
  BaseUserProfile,
  HandledError,
  IPayFastITN,
  ErrorCode,
} from 'fitbeat.models';
import { DbGymRepository } from '../../persistence';
import { UserProfileService } from '../user';
import { UserProfile } from '../../entities';

type AccountAction = {
  type: 'createSubscription';
  subscribeToPrice: string;
  userProfile: UserProfile;
} | { type: 'cancelSubscription' } | { type: 'noAction' };

export const getAccountActionBasedOnITN = async (
  data: IPayFastITN,
  userProfileService: UserProfileService,
): Promise<AccountAction> => {
  const gym = DbGymRepository.getGymByPayfastMerchantId(data.merchant_id);
  if (!gym?.integrationConfig?.payfast) {
    throw new HandledError(
      `no gym setup for payfast merchant id ${data.merchant_id}`,
      ErrorCode.IntegrationError,
    );
  }

  const userProfile = await userProfileService.getUserIdByEmail(data.email_address);
  if (!userProfile) {
    throw new HandledError(
      `user profile for email ${data.email_address} not found`,
      ErrorCode.IntegrationError,
    );
  }
  if (data.payment_status === 'COMPLETE') {
    const userHasActivePayfastSubscription = BaseUserProfile.hasActivePlan(userProfile)
      && userProfile.currentPlanId === gym.integrationConfig?.payfast?.proxyPlanId;
    if (!userHasActivePayfastSubscription) {
      return { type: 'createSubscription', subscribeToPrice: gym.integrationConfig.payfast.proxyPlanId, userProfile };
    }
  } else if (data.payment_status === 'CANCELLED') {
    return { type: 'cancelSubscription' };
  }
  return { type: 'noAction' };
};
